import { render, staticRenderFns } from "./ShopProductBox.vue?vue&type=template&id=23930dee&"
import script from "./ShopProductBox.vue?vue&type=script&lang=js&"
export * from "./ShopProductBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports